module.exports = __webpack_public_path__ + "static/media/IoT模块.2ea9ffb2.png";